<template>
    <div class="gits-container">

        <!--TODO 優惠卷紀錄-->
        <div class="coupon-card" v-if="activeCategory==='coupon'">

            <div class="no-data" v-if="couponRecordList.length === 0">
                <img src="@/assets/images/empty.svg">
                <p>OH！目前空空的</p>
            </div>
            <div class="sort_bar" v-else @click="changeSort()">
                <span>{{couponRecordSortText}}</span>
            </div>

            <ul class="record_content">
                <li v-for="(item, index) in couponRecordList" :key="'couponRecordList'+index">
                    <div class="content">
                        <div class="left">
                            <div class="info">
                                <div class="time">{{item.operatedAt}}
                                    <div class="amount">x {{item.count}}</div>
                                </div>
                                <div class="branch"><b>{{item.brandName}} {{item.storeName}}</b></div>
                                <div class="title">{{item.name}}</div>
                            </div>
                            <ul class="tag">
                                <li v-show="item.stageTime !== ''">場次：{{item.stageTime}}</li>
                                <li v-show="item.message !== ''">留言給對方：{{item.message}}</li>
                                <li v-show="item.note !== ''">備註：{{item.note}}</li>
                                <li v-show="item.useName !== ''">核銷：{{item.useName}}</li>
                            </ul>
                        </div>
                        <div class="right">
                            <div class="status" :class="setStatusClass(item.statusId)">{{item.status}}</div>
                            <div class="user" v-show="item.nickName !== ''">
                                <div class="img">
                                    <div class="image_empty" v-if="item.picture === ''"/>
                                    <el-image v-else :src="item.picture" fit="cover" lazy/>
                                </div>
                                <p>{{item.nickName}}</p>
                            </div>
                        </div>
                    </div>
                </li>
            </ul>
        </div>

        <!--TODO 集點卡紀錄-->
        <div class="coupon-card" v-if="activeCategory==='loyaltyCard'">
            <div class="no-data" v-if="loyaltyCardRecordList.length === 0">
                <img src="@/assets/images/empty.svg">
                <p>OH！目前空空的</p>
            </div>
            <div class="sort_bar" v-else @click="changeSort()">
                <span>{{loyaltyCardRecordSortText}}</span>
            </div>

            <ul class="record_content loyalty">
                <li v-for="(item, index) in loyaltyCardRecordList" :key="'loyaltyCardRecordList'+index">
                    <div class="content">
                        <div class="left">
                            <div class="info">
                                <div class="time">{{item.createdAt}}</div>
                                <div class="branch"><b>{{item.brandName}} {{item.storeName}}</b></div>
                                <div class="title">{{item.listName}}
                                    <div class="amount">x {{item.amount}}</div>
                                </div>
                            </div>
                            <ul class="tag">
                                <li v-show="item.message !== ''">留言給對方：{{item.message}}</li>
                                <li v-show="item.note !== ''">備註：{{item.note}}</li>
                            </ul>
                        </div>
                        <div class="right">
                            <div class="status" :class="setStatusClass(item.statusId)">{{item.status}}</div>
                            <div class="user" v-show="item.name !== ''">
                                <div class="img">
                                    <div class="image_empty" v-if="item.picture === ''"/>
                                    <el-image v-else :src="item.picture" fit="cover" lazy/>
                                </div>
                                <p>{{item.name}}</p>
                            </div>
                        </div>
                    </div>
                </li>
            </ul>
        </div>

        <!--TODO 我的卡片紀錄-->
        <div class="coupon-card" v-if="activeCategory==='card'">
            <div class="no-data">
                <img src="@/assets/images/empty.svg">
                <p>OH！目前空空的</p>
            </div>
            <!--<div class="sort_bar">
                <span>由近到遠</span>
            </div>-->

            <!--                <ul class="record_content card">-->
            <!--                    <li>-->
            <!--                        <div class="content">-->
            <!--                            <div class="left">-->
            <!--                                <div class="info">-->
            <!--                                    <div class="time">2020.08.15 止</div>-->
            <!--                                    <div class="branch">台南府前店</div>-->
            <!--                                    <div class="title">卡片名稱-->
            <!--                                        <div class="amount">x 30</div>-->
            <!--                                    </div>-->
            <!--                                </div> &lt;!&ndash;end of info&ndash;&gt;-->
            <!--                                <ul class="tag">-->
            <!--                                    <li>留言給對方：一起糾團去吃鬆餅啦</li>-->
            <!--                                    <li>備註：上次忘記給券</li>-->
            <!--                                </ul>-->
            <!--                            </div> &lt;!&ndash;end of left&ndash;&gt;-->
            <!--                            <div class="right">-->
            <!--                                &lt;!&ndash;status 有 transfer(轉出)、used(已使用)、invalid(已失效)&ndash;&gt;-->
            <!--                                <div class="status transfer">轉  出</div>-->
            <!--                                <div class="user">-->
            <!--                                    <div class="img"><img src="@/assets/images/img.png"></div>-->
            <!--                                    <p>阿JO</p>-->
            <!--                                </div>-->
            <!--                            </div> &lt;!&ndash;end of right&ndash;&gt;-->
            <!--                        </div> &lt;!&ndash;end of list_content&ndash;&gt;-->
            <!--                    </li>-->
            <!--                </ul>-->
        </div>

        <infinite-loading v-if="setupRecordData" spinner="waveDots" @infinite="getRecordScroll" :distance="200">
            <div slot="no-more">沒有更多資料</div>
            <div slot="no-results"></div>
        </infinite-loading>

        <loading
                :active.sync=isLoading
                :can-cancel="false"
                :is-full-page="true">
        </loading>
    </div>
</template>

<script>
    import {notNull} from '@/util/common';
    import {updateFilterStoreId} from "@/store/mutationTypes";

    const isCouponRecordNear = 0;
    const isCouponRecordFar = 1;

    const isLoyaltyCardRecordNear = 0;
    const isLoyaltyCardRecordFar = 1;

    export default {
        name: "RecordItem",
        props: {
            valueType: {},
            isWeb: {default: false},
        },
        data() {
            return {
                isLoading: false,
                activeCategory: '',
                setupListData: false,
                setupRecordData: false,
                infiniteLoadingListState: '',
                infiniteLoadingRecordState: '',

                //優惠卷相關
                couponOffset: 0,
                couponPageSize: 10,
                couponRecordOffset: 0,
                couponRecordPageSize: 10,
                couponRecordSortType: isCouponRecordNear,
                couponRecordSortText: '由近到遠',
                couponList: [],
                couponRecordList: [],
                isCouponReadCount: 0,

                //集點卡相關
                loyaltyCardOffset: 0,
                loyaltyCardPageSize: 10,
                loyaltyCardRecordOffset: 0,
                loyaltyCardRecordPageSize: 10,
                loyaltyCardRecordSortType: isLoyaltyCardRecordNear,
                loyaltyCardRecordSortText: '由近到遠',
                loyaltyCardList: [],
                loyaltyCardRecordList: [],
                isLoyaltyCardReadCount: 0,

                //卡片相關
                cardOffset: 0,
                cardPageSize: 10,
                cardRecordOffset: 0,
                cardList: [],
                cardRecordList: [],
                isCardReadCount: 0,

                filterStoreId: null, //篩選出某一家店的資料
                removeSubscribe: null,
            }
        },
        created() {
            //取得要單獨過濾的店家ID，line@ web版頁面用
            if (this.isWeb) {
                this.resetByLineWeb();
                this.removeSubscribe = this.$store.subscribe((mutation, state) => {
                    if (mutation.type === updateFilterStoreId) {
                        this.resetByLineWeb();
                    }
                });
            }
        },
        mounted() {
          //避免推播點擊時未正常執行
          setTimeout(()=>{
            this.typeChanged(this.valueType)
          },100)
        },
        activated () {
          //避免推播點擊時未正常執行
          setTimeout(()=>{
            this.typeChanged(this.valueType)
          },100)
        },
        beforeDestroy() {
            if (this.removeSubscribe) {
                this.removeSubscribe();
            }
        },
        methods: {
            typeChanged(activeCategory) {
              let self = this
                this.activeCategory = activeCategory

                this.clearData();
                if (this.infiniteLoadingRecordState !== '') {
                    setTimeout(function (){
                      self.infiniteLoadingRecordState.reset();
                    },100)
                } else {
                    setTimeout(function (){
                      self.setupRecordData = true;
                    },100)
                }
            },
            clearData() {
                this.couponOffset = 0;
                this.couponList = [];
                this.loyaltyCardOffset = 0;
                this.loyaltyCardList = [];
                this.cardOffset = 0;
                this.cardList = [];
                this.couponRecordSortType = isCouponRecordNear
                this.couponRecordSortText = '由近到遠'
                this.couponRecordOffset = 0;
                this.couponRecordList = [];
                this.loyaltyCardRecordSortType = isLoyaltyCardRecordNear
                this.loyaltyCardRecordSortText = '由近到遠'
                this.loyaltyCardRecordOffset = 0;
                this.loyaltyCardRecordList = [];
            },
            getRecordScroll($state) {
                this.infiniteLoadingRecordState = $state
                switch (this.activeCategory) {
                    case "coupon": {
                        this.getCouponRecordListScroll($state);
                        break;
                    }
                    case "loyaltyCard": {
                        this.getLoyaltyCardRecordListScroll($state);
                        break;
                    }
                    case "card": {
                        $state.complete();
                        break;
                    }
                }
            },
            getCouponRecordListScroll($state) {
                let self = this;
                this.isLoading = true;
                this.$http.fetchWithAuth`GetCouponLog${{
                    offset: this.couponRecordOffset,
                    sortType: this.couponRecordSortType,
                    filterStoreId: this.filterStoreId,
                }}
                ${json => {
                    this.isLoading = false;

                    if (notNull(json.data)) {
                        if (json.data.length >= self.couponRecordPageSize) {
                            self.couponRecordOffset++;
                            self.couponRecordList.tmz_load_push(...json.data);
                            $state.loaded();
                        } else {
                            self.couponRecordOffset++;
                            self.couponRecordList.tmz_load_push(...json.data);
                            $state.complete();
                        }
                    } else {
                        $state.complete();
                    }
                }}`;
            },
            getLoyaltyCardRecordListScroll($state) {
                let self = this;
                this.isLoading = true;
                this.$http.fetchWithAuth`GetLoyaltyCardLog${{
                    offset: this.loyaltyCardRecordOffset,
                    sortType: this.loyaltyCardRecordSortType,
                    filterStoreId: this.filterStoreId,
                }} ${json => {
                    this.isLoading = false;

                    if (notNull(json.data)) {
                        if (json.data.length >= self.loyaltyCardRecordPageSize) {
                            self.loyaltyCardRecordOffset++;
                            self.loyaltyCardRecordList.tmz_load_push(...json.data);
                            $state.loaded();
                        } else {
                            self.loyaltyCardRecordOffset++;
                            self.loyaltyCardRecordList.tmz_load_push(...json.data);
                            $state.complete();
                        }
                    } else {
                        $state.complete();
                    }
                }}`;
            },
            changeSort() {
                switch (this.activeCategory) {
                    case "coupon": {
                        if (this.couponRecordSortType === isCouponRecordNear) {
                            this.couponRecordSortType = isCouponRecordFar;
                            this.couponRecordSortText = '由遠到近';
                        } else {
                            this.couponRecordSortType = isCouponRecordNear;
                            this.couponRecordSortText = '由近到遠';
                        }
                        this.couponRecordOffset = 0;
                        this.couponRecordList = [];
                        break;
                    }
                    case "loyaltyCard": {
                        if (this.loyaltyCardRecordSortType === isLoyaltyCardRecordNear) {
                            this.loyaltyCardRecordSortType = isLoyaltyCardRecordFar;
                            this.loyaltyCardRecordSortText = '由遠到近';
                        } else {
                            this.loyaltyCardRecordSortType = isLoyaltyCardRecordNear;
                            this.loyaltyCardRecordSortText = '由近到遠';
                        }
                        this.loyaltyCardRecordOffset = 0;
                        this.loyaltyCardRecordList = [];
                        break;
                    }
                    case "card": {
                        break;
                    }
                }
                this.infiniteLoadingRecordState.reset();
            },
            setStatusClass(statusId) {
                switch (statusId) {
                    case  1:
                        return 'used';
                    case  2:
                        return 'transfer';
                    case  3:
                        return 'invalid';
                    case  4:
                        return 'transIn';
                }
            },
            resetByLineWeb() {
                this.filterStoreId = this.$store.state.lineAtWebPageData.filterStoreId;
            },
        },
        watch: {
            valueType() {
              this.typeChanged(this.valueType)
            },
        }
    }
</script>

<style lang="less" scoped src="../../../less/gift.less"/>